import { createContext, useContext } from 'react';
import { TimezoneProvider } from '@facephi/ui-react';
import { ApiProvider } from './ApiProvider';
import { TranslationProvider } from './TranslationProvider';

type Props = {
  children: React.ReactNode;
  language: string;
  apiUrl?: string;
  wsApiUrl?: string;
  companyId?: string;
  onDetail?: (id: string) => void;
  token?: string;
};

type ContextProps = Pick<
  Props,
  'apiUrl' | 'wsApiUrl' | 'companyId' | 'onDetail'
>;

const Ctx = createContext<ContextProps>({});

export const BehaviourProvider = ({
  children,
  apiUrl,
  wsApiUrl,
  companyId,
  language,
  onDetail,
  token,
}: Props) => {
  return (
    <Ctx.Provider
      value={{
        apiUrl,
        wsApiUrl,
        companyId,
        onDetail,
      }}
    >
      <TranslationProvider language={language}>
        <TimezoneProvider locale={language}>
          <ApiProvider token={token}>{children}</ApiProvider>
        </TimezoneProvider>
      </TranslationProvider>
    </Ctx.Provider>
  );
};

export const useBehaviour = () => useContext(Ctx);
